import React from 'react';
import {  Routes, Route } from 'react-router-dom';
import './GlobalUtilities/css/App.css';
import LoginPage  from './GlobalUtilities/login/LoginPage.js';

import PublicRoutes from "./GlobalUtilities/protection/publicRoutes.js";

import useAdmin from "./GlobalUtilities/protection/useAdmin.js";

import { USER_RIGHTS } from "./GlobalUtilities/constants/Constants.js";
import { useAuthentication } from "./GlobalUtilities/customHook/useAuthentecation.js";

function App() {


  const { auth } = useAuthentication();

  const adminRoutes = useAdmin();
  // const consigneeRoutes = useConsigneeRoutes();
  // const cosgRoutes = useCOSG();
  // const sseadmRoutes = useSSEADM();
  // const accountRoutes = useAccounts();
  // const sseiRoutes = useSSEI();

//console.log(useAuthentication());


//console.log("here",auth?.right); 
  return (
   
    //   {/* <Routes>
        
    //     <Route path="/" element={<LoginPage />} />
    //     <Route path="/dashboard" element={<DashBoard />} />
    //   </Routes> */}
      
    //   <Routes>
    //   {auth?.userrights === USER_RIGHTS.ADMIN && adminRoutes}
    //   <Route element={<PublicRoutes />}>
    //     <Route
    //       // index
    //       element={
    //         // {/* LOGIN */}
    //         <LoginPage />
    //       }
    //       path="/"
    //     />
    //   </Route>
    // </Routes>
    <>
    <Routes>
   
   {auth?.right === USER_RIGHTS.ADMIN && adminRoutes} 



      
      <Route element={<PublicRoutes />}>
        <Route  element={<LoginPage />}   path="/"  />
      </Route>
    </Routes>
  </>
   
  );
}

export default App;
